import { render, staticRenderFns } from "./BoardList.vue?vue&type=template&id=0ea2c604&scoped=true"
import script from "./BoardList.ts?vue&type=script&lang=ts&external"
export * from "./BoardList.ts?vue&type=script&lang=ts&external"
import style0 from "./BoardList.vue?vue&type=style&index=0&id=0ea2c604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea2c604",
  null
  
)

export default component.exports